module.exports = {
	"pathContext": {
		"name": "budapest",
		"photos": [
			"budapest/DSC_0566.jpg",
			"budapest/DSC_0568.jpg",
			"budapest/DSC_0572.jpg",
			"budapest/DSC_0573.jpg",
			"budapest/DSC_0582.jpg",
			"budapest/DSC_0583.jpg",
			"budapest/DSC_0611.jpg",
			"budapest/DSC_0638.jpg",
			"budapest/DSC_0649.jpg",
			"budapest/DSC_0655.jpg",
			"budapest/DSC_0660.jpg",
			"budapest/DSC_0667.jpg",
			"budapest/DSC_0671.jpg",
			"budapest/DSC_0676.jpg",
			"budapest/DSC_0682.jpg",
			"budapest/DSC_0685.jpg",
			"budapest/DSC_0690.jpg",
			"budapest/DSC_0694.jpg",
			"budapest/DSC_0695.jpg",
			"budapest/DSC_0698.jpg",
			"budapest/DSC_0707.jpg",
			"budapest/DSC_0712.jpg",
			"budapest/DSC_0713.jpg",
			"budapest/DSC_0738.jpg",
			"budapest/DSC_0741.jpg",
			"budapest/DSC_0742.jpg",
			"budapest/DSC_0757.jpg",
			"budapest/DSC_0763.jpg",
			"budapest/DSC_0767.jpg",
			"budapest/DSC_0769.jpg",
			"budapest/DSC_0785.jpg",
			"budapest/DSC_0797.jpg",
			"budapest/DSC_0807.jpg",
			"budapest/DSC_0813.jpg",
			"budapest/DSC_0822.jpg",
			"budapest/DSC_0826.jpg"
		],
		"next": {
			"name": "oslo"
		},
		"previous": {
			"name": "vienna"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/photos-budapest.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/photos-budapest.json
// module chunks = 1043004106977051900